import * as React from "react";
import Vendors from "src/pages/Vendors";
import Layout from "@components/Layout";
import Head from "next/head";

const Index = () => {
  return (
    <Layout>
      <Head>
        <title>Inawo Vendors</title>
        <meta
          name="description"
          content="Join Inawo Vendors to showcase your services, receive bookings, and grow your wedding business with better visibility."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Head>
      <Vendors />
    </Layout>
  );
};

export default Index;
